module.exports = __webpack_public_path__ + "img/check-verified-01.59dcc06d.svg";